<template>
  <div v-if="isShowPage">
    <div class="order-detail" ref="orderDetail" v-if="isList">
      <div class="tab-box">
        <div class="tab-item cur">活动订单</div>
        <div class="tab-item" @click="goNextPage">商城意向单</div>
      </div>
      <div class="card-box">
        <OrderCard :payerDisabled="false"
                   :MajorGuestID="MajorGuestId"
                   :countries="countries"
                   :payList="majorGuestList"
                   :bookingContact="bookingContact"
                   :displayOrder="displayOrder"
                   @checkName="checkNames"
                   @checkContacts="checkContacts"
                   @switch="refreshContactInfo"
        />
      </div>
      <div v-show="orderShow">
        <ShoppingCartCard v-for="(item,index) in shopCartItems" :key="index" :cardTitle="item.name">
          <EnterainmentCard :cardData="item.children" :isShowRadio="false" :isShow="false"/>
        </ShoppingCartCard>

        <!--超凡观光-->
        <div v-if="listData.shorex" class="card-box">
          <ShoppingCartCard :cardTitle="'超凡观光'">
            <SightseeingCard ref="checkRef"
                             :is-show-radio="false"
                             :isShowTour="(!isFromCart && orderChange) || isTerms"
                             :cardData="ShorexPartViews"
                             :personNumber="listData.bookingGuests.length"
                             :isBookingDeatail="true"
                             :bookingShoreType="ShorexPartViews[0].shorexType"
                             :isTerms="isTerms"/>
          </ShoppingCartCard>
        </div>
        <div v-else>
          <template v-if="!listData.shorex && !listData.hasShorexSubOrder">
            <ShoppingCartCard :cardTitle="'超凡观光'">
              <div class="noShoreDate">

                  <div>尊敬的客人，您尚未预订任何岸上观光行程。皇家官方为您提供多种岸上观光行程，您可自主进行选订。 如不进行任何行程选订则视为自助游，您需自行安排目的地游览行程。</div>
                  <div class="goToBook" @click="goToShorex">前往预订</div>

              </div>
            </ShoppingCartCard>
            <div @click="goToShorex" class="noShorexKv">
              <img src="https://resource.rcclchina.com.cn/cruiseDetail/shorexCompTour/miniKv.png" alt="">
            </div>
          </template>
        </div>
        <!--合计-->
        <div class="card-box">
          <div class="total-box flex-center-box card-cell">
            <div class="title">总计：</div>
            <div class="price"><span class="price-color">{{total}}</span> 美元</div>
          </div>
        </div>

        <!--皇家行前条款-->
        <div class="card-box" v-if="!isTerms">
          <TermsCard :termsCheck.sync="termsCheck"/>
        </div>

        <template v-if="money > 0">
          <!-- fixed 定位后 高度适应 -->
          <div class="bottom-bar-height">

          </div>

          <div class="bottom-bar">
            <!-- 50消费抵用券 bar -->
            <OffsetfiftyBar isFixed :money="money" isShowbg/>
          </div>
        </template>
        

        <!--提交订单-->
        <div v-show="isFromCart">
          <van-button class="bottom-btn" block @click="submitOrder('submit')">提交订单</van-button>
        </div>
<!--        <div v-show="isFromCart || !orderChange">-->
<!--          <van-button class="bottom-btn" block @click="submitOrder('submit')" v-if="!isTerms">提交订单</van-button>-->
<!--          <van-button class="bottom-btn" block @click="submitOrder('change')" v-else>更改订单</van-button>-->
<!--        </div>-->
<!--        <van-button v-show="!isFromCart && orderChange" class="bottom-btn toCart" block @click="goCart()">-->
<!--          您的订单有新增修改，请去<span class="underline">购物车</span>确认<br/>如未确认，保留原订单-->
<!--        </van-button>-->
      </div>
    </div>
    <EmptyShoppingCart v-if="!isShowPage"/>

   
  </div>
</template>

<script>
import EnterainmentCard from './shopping_cart/EntertainmentCard'
import SightseeingCard from './shopping_cart/SightseeingCard'
import OrderCard from './order_detail/OrderCard'
import TermsCard from './order_detail/TermsCard'
import ShoppingCartCard from './shopping_cart/ShoppingCartCard'
import EmptyShoppingCart from './shopping_cart/EmptyShoppingCart'
import api from '@/api'
import {showLoading, hideLoading, showAlert, checkTel, checkMail, isEmpty} from '@/utils/tools'
// import groupBy from 'lodash/groupBy'
// import { Dialog } from 'vant'
import {checkLoginStatus, toShoppingMall, gioTracking, getShoppingCartNum, getGetAvailableCouponCount} from '@/plugins/common.js'
import { deleteCookie } from '@/utils/cookie'
import {mapState} from "vuex";
import OffsetfiftyBar from '@/components/coupon/OffsetfiftyBar.vue'


export default {
  name: 'PageOrderDetail',

  components: {
    EnterainmentCard,
    SightseeingCard,
    OrderCard,
    TermsCard,
    ShoppingCartCard,
    EmptyShoppingCart,
    OffsetfiftyBar,
  },

  data () {
    return {
      isTerms: false,
      listData: {},
      shopCartItems: {},
      ShorexPartViews: [],
      termsCheck: false,
      MajorGuestId: '',
      isList: false,
      total: 0,
      isShowPage: true,
      orderShow: false,
      orderChange: false,
      isFromCart: false,
      orderId: '',
      countries: null,
      bookingContact: null,
      updateFields:[], //更新的字段
      majorGuestList: [],
      shoppingCartIds: [],
      money:''
    }
  },

  filters: {
    priceFormat (current) {
      return current % 1 === 0 ? current : current.toFixed(2)
    }
  },
  created() {
    console.log(this.isMaskValue,'isMaskValue')
    this.getCallingCode();
  },
  mounted () {
    this.getMoney()
    this.isShowPage = true
    const { isFromCart, shoppingCartIds } = this.$route.query
    if (isFromCart === 'true') {
      this.isFromCart = true
    }
    if (shoppingCartIds) {
      this.shoppingCartIds = shoppingCartIds.split(',').map(r=> parseInt(r));
    }
    console.log(shoppingCartIds)
    console.log(this.shoppingCartIds)
    checkLoginStatus().then(() => {
      api.getBookingInfo(true).then((res) => {
        if (res.errCode === 0) {
          this.orderId = res.data.orderId;
          this.majorGuestList = res.data.bookingGuests
          this.bookingContact = Object.assign({
            bookingContactName: this.formatBookingContact(res.data.bookingContact)
          }, res.data.bookingContact);
          this.bookingContact.callingCode = this.bookingContact.callingCode || '86';
          console.log('bookingContact',this.bookingContact)
          this.getOrderFrom(res.data.orderId)
        } else {
          this.isShowPage = false
          showAlert(res.errMsg)
        }
      }).catch(erro => {
        console.log(erro)
      })
    })
  },

  methods: {
    async getMoney() {
      const {errCode, data} = await api.getGetObcInfo();
      if (errCode === 0) {
        // console.log('getMoneygetMoneygetMoney', data)
        this.money = data ? data.remainingObcAmount :'0'
      } 
    },
    goNextPage () {
      toShoppingMall('order')
    },
    goCart () {
      this.$router.push('/page_shopping_cart')
    },

    displayOrder () {
      this.orderShow = true
    },
    // 提交订单
    submitOrder (val) {
      if (val === 'submit') {
        let bookingContact = this.bookingContact;
        console.log(this.bookingContact)
        if(!bookingContact.bookingContactName) {
          showAlert('请填写联系人').then(() => {
            window.scroll({ top: 0, left: 0, behavior: 'smooth' })
          });
          return;
        }
        if(!bookingContact.telephone) {
          showAlert('请填写手机号').then(() => {
            window.scroll({ top: 0, left: 0, behavior: 'smooth' })
          });
          return;
        }

          if(!this.isMaskValue || this.updateFields.includes("contactMobileNo")) {
            if(bookingContact.callingCode === '86' && (bookingContact.telephone.length < 11 || !checkTel(bookingContact.telephone))) {
              showAlert('请输入正确的手机号码').then(() => {
                window.scroll({ top: 0, left: 0, behavior: 'smooth' })
              });
              return;
            }
          }
        if(!bookingContact.email) {
          showAlert('请填写邮箱').then(() => {
            window.scroll({ top: 0, left: 0, behavior: 'smooth' })
          });
          return;
        }
        //Email
        if(!this.isMaskValue || this.updateFields.includes("ContactEmailAddress")){
          if(!checkMail(bookingContact.email)) {
            showAlert('请输入正确的邮箱').then(() => {
              window.scroll({ top: 0, left: 0, behavior: 'smooth' })
            });
            return;
          }
        }


        if (this.termsCheck) {
          this.setPayPerson()
          this.setBookingContact();
          this.submitOrders()
        } else {
          showAlert('请阅读并确认条款').then(() => {
            window.scroll({ top: this.$refs.orderDetail.clientHeight, left: 0, behavior: 'smooth' })
          })
        }
        console.log('updatefieds',this.updateFields)
      } else {
        // Dialog.confirm({
        //   message: '请确认是否需要修改订单'
        // }).then(() => {
        //   this.editOrders()
        // })
      }
    },
    // 预定支付人
    checkNames (val) {
      this.MajorGuestId = val
      this.updateFields.push('MajorGuestId')
    },
    // 联系人信息
    checkContacts (value) {
      switch (value.key) {
        case 'telephone':
          this.bookingContact.telephone = value.val;
          if(!this.updateFields.includes('contactMobileNo')) {
            this.updateFields.push('contactMobileNo')
          }
          break;
        case 'callingCode':
          this.bookingContact.callingCode = value.val;
          if(!this.updateFields.includes('ContactCallNo')) {
            this.updateFields.push('ContactCallNo')
          }
          break;
        case 'bookingContactName':
          this.bookingContact.bookingContactName = value.val;
          if(!this.updateFields.includes('BookingContactName')) {
            this.updateFields.push('BookingContactName')
          }
          // this.updateFields.push('BookingContactName')
          break;
        default:
          this.bookingContact.email = value.val || null;
          if(!this.updateFields.includes('ContactEmailAddress')) {
            this.updateFields.push('ContactEmailAddress')
          }
          // this.updateFields.push('ContactEmailAddress')
          break;
      }
    },
    // 判断路径来源，读取不同订单内容接口
    async getOrderFrom (val) {
      if (this.isFromCart) {
        this.getBookingInfo(val)
      } else {
        this.getOriginBookingInfo()
      }
    },

    // 获取订单列表API
    async getBookingInfo (val) {
      showLoading()
      const { errCode, errMsg, data } = await api.getOrderDetail({
        orderId: val,
        shoppingCartIds: this.shoppingCartIds
      })
      hideLoading()
      if (errCode === 0) {
        if (data) {
          this.listData = data
          this.total = data.total
          // this.ShopCartItems = groupBy(data.shopCartItems, 'categoryName')
          const newarr = this.groupArr(data.shopCartItems, 'categoryName')
          for (let index = 0; index < newarr.length; index++) {
            newarr[index].children = this.groupArr(newarr[index].children, 'subCategoryName')
          }
          this.shopCartItems = newarr
          this.ShorexPartViews = []
          this.ShorexPartViews[0] = data.shorex
          if (data.majorGuestId == null) {
            this.MajorGuestId = this.majorGuestList[0].id
          } else {
            this.MajorGuestId = data.majorGuestId
          }
          if (data.shopCartItems.length > 0 || data.shorex !== null) {
            this.isList = true
          } else {
            this.isList = true
          }
          this.setPayPerson();
          this.setBookingContact();
        }
      } else {
        // 无订单
        window.console.log(errMsg)
        this.isList = true
        this.orderShow = false
      }
    },
    // 获取已提交订单列表API
    async getOriginBookingInfo () {
      showLoading()
      const { errCode, errMsg, data } = await api.getOriginOrderDetail()
      hideLoading()
      if (errCode === 0) {
        if (data) {
          this.listData = data
          this.total = data.total
          // this.ShopCartItems = groupBy(data.shopCartItems, 'categoryName')
          const newarr = this.groupArr(data.shopCartItems, 'categoryName')
          for (let index = 0; index < newarr.length; index++) {
            newarr[index].children = this.groupArr(newarr[index].children, 'subCategoryName')
          }
          this.shopCartItems = newarr
          this.ShorexPartViews = []
          this.ShorexPartViews[0] = data.shorex
          if (data.majorGuestId == null) {
            this.MajorGuestId = data.bookingGuests[0].id
          } else {
            this.MajorGuestId = data.majorGuestId
          }
          if (data.shopCartItems.length > 0 || data.shorex !== null) {
            this.isList = true
          } else {
            this.isList = true
          }
          this.setPayPerson();
          this.setBookingContact();
        }
      } else {
        // 无订单
        console.log(errMsg)
        this.isList = true
        this.orderShow = false
      }
    },
    // 重制预定支付人
    setPayPerson () {
      const guestsData = this.listData.bookingGuests
      guestsData && guestsData.some((curitem) => {
        if (curitem.id === this.MajorGuestId) {
          this.$store.state.bindTicket.pinyinLastName = curitem.pinYinLastName
          this.$store.state.bindTicket.pinyinFirstName = curitem.pinYinFirstName
        }
      })
    },
    // 重制联系人
    setBookingContact() {
      const bookingContactInfo = this.bookingContact;
      this.$store.commit('setBookingContactInfo',bookingContactInfo)
      // this.$store.state.bookingContactInfo = Object.assign({}, bookingContactInfo)
    },
    // TODO 提交订单API
    async submitOrders () {
      showLoading()
      let bookingContact = this.bookingContact;
      const updata = {
        MajorGuestId: this.MajorGuestId,
        Source: 'Mobile',
        contactEmailAddress: bookingContact.email,
        contactMobileNo: bookingContact.telephone,
        contactCallNo: bookingContact.callingCode,
        bookingContactName: bookingContact.bookingContactName,
        UpdateFields:this.updateFields, //修改的字段
        shoppingCartIds: this.shoppingCartIds
      }
      if (navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1) {
        updata.Source = 'wechat'
      } else {
        updata.Source = 'Mobile'
      }
      const { errCode, errMsg } = await api.submitOrder(updata)
      hideLoading()
      if (errCode === 0) {
        await this.refreshContactInfo()
        this.setBookingContact();
        gioTracking('track','evt_submitOrder', {'PCPOrderID': this.orderId,'productCount': this.goodsCartNum})
        this.$router.push('/pgae_order_success')
        await getShoppingCartNum();
        await getGetAvailableCouponCount();
      } else {
        showAlert(errMsg)
      }
    },
    // 更改订单API
    async editOrders () {
      showLoading()
      const { errCode, errMsg } = await api.editOrder()
      hideLoading()
      if (errCode === 0) {
        gioTracking('track','evt_submitOrder', {'PCPOrderID': this.orderId,'productCount': this.goodsCartNum})
        deleteCookie('shorexId')
        this.$router.push('/page_shopping_cart')
      } else {
        showAlert(errMsg)
      }
    },
    // 订单状态查询
    async checkOrdersStatus () {
      showLoading()
      const { errCode, errMsg, data } = await api.checkOrderStatus()
      hideLoading()
      if (errCode === 0) {
        if (this.isFromCart) {
          if (data.orderIsInChange || data.orderStatus === 0) {
            this.isTerms = true
          } else {
            this.isTerms = false
          }
        }
        if (data.orderIsInChange) {
          this.orderChange = true
        }
      } else {
        showAlert(errMsg).then(() => {
          this.$router.push(this.$store.getters.isLogin ? '/bind_ticket' : '/login')
        })
      }
    },
    groupArr (list, field) {
      let fieldList = []
      const att = []
      list.map(e => {
        fieldList.push(e[field])
      })
      fieldList = fieldList.filter((e, i, arr) => {
        return arr.indexOf(e) === i
      })
      for (let index = 0; index < fieldList.length; index++) {
        const arr = list.filter(e => {
          return e[field] === fieldList[index]
        })
        att.push({
          name: arr[0][field],
          children: arr
        })
      }
      return att
    },
    async getCallingCode () {
      showLoading()
      const { errCode, errMsg, data } = await api.getCallingCode()
      hideLoading()
      if (errCode === 0) {
        if (data.rows && data.rows.length > 0) {
          this.countries = data.rows;
        }
      } else {
        showAlert(errMsg || '获取区号失败，请稍后重试')
      }
    },
    refreshContactInfo(){
      showLoading()
      api.getBookingInfo().then((res) => {
        if (res.errCode === 0) {
          this.orderId = res.data.orderId;
          this.bookingContact = Object.assign({
            bookingContactName: this.formatBookingContact(res.data.bookingContact)
          }, res.data.bookingContact);
          this.bookingContact.callingCode = this.bookingContact.callingCode || '86';
           this.getOrderFrom(res.data.orderId)
          this.updateFields=[]//切换掩码之后需要清空修改的数组
        } else {
          this.isShowPage = false
          showAlert(res.errMsg)
        }
      }).catch(error => {
        console.log(error)
      }).finally(()=>{
        hideLoading()
      })
    },
    goToShorex(){
      this.$router.push({
        path:'/Rccl.PCP/product/pcpShorex'
      })
    },
    formatBookingContact(bookingContact) {
      const { chineseLastName, chineseFirstName, pinYinLastName, pinYinFirstName } = bookingContact;
      let bookingContactName = ""
      if(!isEmpty(chineseLastName) && !isEmpty(chineseFirstName)) {
        bookingContactName=chineseLastName+chineseFirstName
      }
      let bookingContactNamePY = ""
      if(!isEmpty(pinYinLastName) && !isEmpty(pinYinFirstName)) {
        bookingContactNamePY=pinYinLastName+pinYinFirstName;
      }
      return !isEmpty(bookingContactName) ? bookingContactName : !isEmpty(bookingContactNamePY) ? bookingContactNamePY : ""
    }
  },
  computed: {
    ...mapState(['isMaskValue']),
    goodsCartNum () {
      return this.$store.state.goodsCartNum || 0
    }
  }

}
</script>

<style lang="less" scoped>
.order-detail{
  padding: 57px 50px 127px;
  position: relative;
  .btn-privacy{
    position: absolute;
    right: 20px;
    top: -50px;
  }
  .tab-box {
    background-color: #e8ecef;
    border-radius: 10Px 10Px 0 0;
    font-size: 30px;
    color: #999999;
    text-align: center;
    display: flex;
    justify-content: center;
    overflow: hidden;
    .tab-item {
      padding: 20px 0;
      width: 50%;
      &.cur{
        color: #001366;
        background: url(../assets/order_detail_tab_cur_bj.png) no-repeat center;
        background-size: cover;
      }
    }
  }
  .card-box{
    margin-bottom: 20px;
  }
  ::v-deep .card-cell {
    background-color: #ffffff;
    border-radius: 6px;
    overflow: hidden;
    font-size: 18px;
    color: @main-gray4;
    line-height: 1.8;
    // .item-top-tag{
    //   font-size: 24px;
    //   color: @main-gray3;
    //   padding: 5px 20px;
    //   background-color: #f0f0f0;
    //   margin-bottom: 20px;
    //   display: inline-block;
    //   border-radius: 46px;
    // }
    .card-hd {
      font-size: 30px;
      color: @main-gray2;
      padding: 20px;
      border-bottom: 1px solid @cart-card-border;
    }
    .card-bd{
      min-height: 100px;
    }
  }
  ::v-deep .item-btn{
    width: 85px;
    height: 46px;
    line-height: 46px;
    background-color: #1174b8;
    color: #ffffff;
    display: inline-block;
    text-align: center;
    margin-right: 10px;
    border-radius: 6px;
    font-size: .18rem;
    padding: 0;
    border:none;
    &.btn-linear-gradient{
      color: @main-gray2;
    }
  }
  ::v-deep .price-color{
    color: @second-color;
    font-weight: bold;
  }
  ::v-deep .blue-color{
    color: #1174b8;
  }
  ::v-deep .van-checkbox__icon{
    width: .28rem;
    height: .28rem;
    img{
      width: 100%;
      vertical-align: top;
    }
  }
  .bottom-bar-height{
    height:60px;
  }
  .bottom-bar{
    position: fixed;
    bottom: 227px;
    left: 0;
    right: 0;
    z-index: 90;
  }
  .bottom-btn{
    position: fixed;
    bottom: 126px;
    left: 0;
    right: 0;
    height: 117px;
    background-color: @second-color;
    color: #ffffff;
    line-height: 117px;
    text-align: center;
    font-size: 30px;
    z-index: 90;
  }
  .toCart {
    font-size: 28px;
    line-height: 40px;
    .underline {
      color: #1174b8;
      text-decoration: underline;
    }
  }
  .total-box{
    font-size: 24px;
    padding: 20px 30px;
    color: @main-gray2;
    .price{
      color: @main-gray4;
      .price-color{
        font-size: 36px;
      }
    }
  }
}
.noShoreDate{
  background-color: #f6f7f9;
  padding: 30px;
  color: #000000;
  font-size: 24px;
  line-height: 35px;
  .goToBook{
    margin: 30px auto;
    padding: 10px 30px;
    width: 130px;
    background-color: #fcc302;
    color: #fff;
    text-align: center;
    font-size: 24px;
    border-radius: 6px;
  }
}
.noShorexKv{
  width: 100%;
  height: 102px;
  border-radius: 10px;
  overflow: hidden;
  img{
    display: block;
    width: 100%;
    height: 100%;
  }
}
</style>
